import React from "react";
import Modal from "../shared/Modal";
import "./ModalPolicyStudioGate.css";
import { HUBSPOT_SIGNUP_LINK } from "../../config";
interface ModalPolicyStudioGateProps {
  isOpen: boolean;
  title: string;
  body: string;
}

export const ModalPolicyStudioGate: React.FC<ModalPolicyStudioGateProps> = ({
  isOpen,
  title,
  body,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      style={{ width: "100vh", height: "90vh" }}
      canClose={false}
      escapeToClose={false}
      allowClickout={false}>
      <div className="modal-text-input">
        <div className="modal-text-input-title">
          <h2>{title}</h2>
        </div>
        <div className="modal-text-input-body">
          <div className="modal-text-input-content">
            {body}
            <iframe
              className="modal-text-input-iframe"
              src={HUBSPOT_SIGNUP_LINK}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
